import React from "react";
import "./Resources.css";
import { Fade } from "react-awesome-reveal";

const Resources = () => {
    return (
        <div className="resources-slide" id="resources">
            <Fade direction="up" duration={1500} cascade damping={0.3} triggerOnce>
                <h1>Resources</h1>
            </Fade>
            <div className="resources-container">
                <div className="resources-card">
                    <Fade direction="left" duration={1500} cascade damping={0.3} triggerOnce>
                        <a href="https://paincenter.utdallas.edu/sensoryomics-resources/" target="_blank" rel="noopener noreferrer">
                            <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" id="sensorymoics-resources-svg">
                                <path d="m10 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm-8 10c0-.61.08-1.21.21-1.78l4.78 4.78v1c0 1.1.9 2 2 2v1.93c-3.93-.5-6.99-3.86-6.99-7.93zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1v-2h2c1.1 0 2-.9 2-2v-.41c2.93 1.18 5.01 4.06 5.01 7.41 0 2.08-.81 3.98-2.11 5.4z" fill="white"></path>
                            </svg>
                            <h3>Sensoryomics Resources</h3></a>
                        <p>Learn more about the experiments, the protocols, the papers and the data on this site.</p>
                    </Fade>

                </div>

                <div className="resources-card">
                    <Fade direction="right" duration={1500} cascade damping={0.3} triggerOnce>
                        <a href="https://www.instagram.com/reel/Cx8cKABLsQh/" target="_blank" rel="noopener noreferrer">
                            <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="">
                                <path d="M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z" fill="white"></path>
                            </svg>
                            <h3>Learn more about the hDRG</h3></a>
                        <p>Dr. Price Steps into a human dorsal root ganglion and explains some of its features.</p>
                    </Fade>
                </div>
            </div>
        </div>
    );
}

export default Resources;